const uxComponentsList = [
    { id: 'blank', text: "Empty space", icon: "isblank" },
	{ id: 'list', text: "List", icon: "fields" },
	{ id: 'datagrid', text: "DataGrid", icon: "tableproperties", defaultSettings: {
        showColumnChooser: true,
        editingMode: 'row',
		showBorders: true,
		showRowLines: true,
		showColLines: false,
		showZebra: false,
		disallowImport: true,
    } },
	{ id: 'calendar', text: "Calendar", icon: "clock" },
	{ id: 'imageview', text: "Image", icon: "image" },
	{ id: 'gallery', text: "Gallery", icon: "smalliconslayout" },
	{ id: 'chart', text: "Chart", icon: "dataarea" },
	{ id: 'itemview', text: "Item Viewer", icon: "verticalaligntop" },
	{ id: 'drive', text: "Drive", icon: "folder" },
	{ id: 'html', text: "Editor", icon: "font", defaultSettings: {
		content: '',
		htmlMode: 'simple',
	}},
	{ id: 'delete', text: "Remove cell", icon: "remove" },
];

export { uxComponentsList };
